import { call, put, takeLatest } from "redux-saga/effects";
import UsuariosActions, {
  Types as UsuariosTypes,
} from "../../stores/usuarios/Actions";
import UsuariosService from "../../services/usuarios/UsuariosService";
import AuthService from "../../services/auth/AuthService";
import ResponseCode from "../../services/ResponseCode";

function* consultarUsuarios(request) {
  yield put(UsuariosActions.consultarUsuariosLoading());

  try {
    const response = yield call(AuthService.getUsers, request.payload);

    if (!response?.response) {
      yield put(
        UsuariosActions.consultarUsuariosFailure({
          codigo: ResponseCode.SERVER_ERROR.code,
          mensaje: ResponseCode.SERVER_ERROR.message,
        })
      );
      return;
    }

    if (response?.response?.code !== ResponseCode.USER_AUTHENTICATED.code) {
      yield put(
        UsuariosActions.consultarUsuariosFailure({
          codigo: response?.response?.code,
          mensaje: response?.response?.message,
        })
      );
      return;
    }

    if (response?.data) {
      yield put(UsuariosActions.consultarUsuariosSuccess(response.data));
    } else {
      yield put(
        UsuariosActions.consultarUsuariosFailure({
          codigo: ResponseCode.SERVER_ERROR.code,
          mensaje: "Datos de respuesta inválidos",
        })
      );
    }
  } catch (error) {
    yield put(
      UsuariosActions.consultarUsuariosFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: "Error al consultar usuarios: " + error.message,
      })
    );
  }
}

function* obtenerRecursos(request) {
  yield put(UsuariosActions.obtenerRecursosLoading());

  try {
    const response = yield call(AuthService.getResource, request.payload);

    if (!response?.response) {
      yield put(
        UsuariosActions.obtenerRecursosFailure({
          codigo: ResponseCode.SERVER_ERROR.code,
          mensaje: ResponseCode.SERVER_ERROR.message,
        })
      );
      return;
    }

    if (response?.response?.code !== ResponseCode.OK.code) {
      yield put(
        UsuariosActions.obtenerRecursosFailure({
          codigo: response?.response?.code,
          mensaje: response?.response?.message,
        })
      );
      return;
    }

    if (response?.data) {
      yield put(UsuariosActions.obtenerRecursosSuccess(response.data));
    } else {
      yield put(
        UsuariosActions.obtenerRecursosFailure({
          codigo: ResponseCode.SERVER_ERROR.code,
          mensaje: "Datos de recursos inválidos",
        })
      );
    }
  } catch (error) {
    yield put(
      UsuariosActions.obtenerRecursosFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: "Error al obtener recursos: " + error.message,
      })
    );
  }
}

function* asignarRol(request) {
  yield put(UsuariosActions.asignarRolLoading());

  try {
    const response = yield call(AuthService.assignRole, request.payload);

    if (!response?.response) {
      yield put(
        UsuariosActions.asignarRolFailure({
          codigo: ResponseCode.SERVER_ERROR.code,
          mensaje: ResponseCode.SERVER_ERROR.message,
        })
      );
      return;
    }

    if (!response?.response?.success) {
      yield put(
        UsuariosActions.asignarRolFailure({
          codigo: response?.response?.code,
          mensaje: response?.response?.message,
        })
      );
      return;
    }

    yield put(
      UsuariosActions.asignarRolSuccess({
        usuario: request.payload.requestData.username,
        rol: request.payload.requestData.roleId,
      })
    );

    if (request.payload.searchTerm) {
      yield call(consultarUsuarios, {
        payload: {
          searchTerm: request.payload.searchTerm,
          requestHeaders: request.payload.requestHeaders,
        },
      });
    }
  } catch (error) {
    yield put(
      UsuariosActions.asignarRolFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: "Error al asignar rol: " + error.message,
      })
    );
  }
}

function* removerRol(request) {
  yield put(UsuariosActions.removerRolLoading());

  try {
    const response = yield call(AuthService.deleteRole, request.payload);

    if (!response?.response) {
      yield put(
        UsuariosActions.removerRolFailure({
          codigo: ResponseCode.SERVER_ERROR.code,
          mensaje: ResponseCode.SERVER_ERROR.message,
        })
      );
      return;
    }

    if (!response?.response?.success) {
      yield put(
        UsuariosActions.removerRolFailure({
          codigo: response?.response?.code,
          mensaje: response?.response?.message,
        })
      );
      return;
    }

    yield put(
      UsuariosActions.removerRolSuccess({
        usuario: request.payload.requestData.username,
        rol: request.payload.requestData.roleId,
      })
    );

    if (request.payload.searchTerm) {
      yield call(consultarUsuarios, {
        payload: {
          searchTerm: request.payload.searchTerm,
          requestHeaders: request.payload.requestHeaders,
        },
      });
    }
  } catch (error) {
    yield put(
      UsuariosActions.removerRolFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: "Error al remover rol: " + error.message,
      })
    );
  }
}

function* obtenerUsuario(request) {
  yield put(UsuariosActions.obtenerUsuarioLoading());

  try {
    const response = yield call(
      UsuariosService.obtenerUsuario,
      request.payload
    );

    if (
      !response?.respuesta ||
      response?.respuesta?.codigo === ResponseCode.SERVER_ERROR.code
    ) {
      yield put(
        UsuariosActions.obtenerUsuarioFailure({
          codigo: ResponseCode.SERVER_ERROR.code,
          mensaje: ResponseCode.SERVER_ERROR.message,
        })
      );
      return;
    }

    if (response?.respuesta?.codigo !== ResponseCode.OK.code) {
      yield put(UsuariosActions.obtenerUsuarioFailure(response?.respuesta));
      return;
    }

    if (response?.data) {
      yield put(UsuariosActions.obtenerUsuarioSuccess(response.data));
    } else {
      yield put(
        UsuariosActions.obtenerUsuarioFailure({
          codigo: ResponseCode.SERVER_ERROR.code,
          mensaje: "Datos de usuario inválidos",
        })
      );
    }
  } catch (error) {
    yield put(
      UsuariosActions.obtenerUsuarioFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: "Error al obtener usuario: " + error.message,
      })
    );
  }
}

const exportedArray = [
  takeLatest(UsuariosTypes.CONSULTAR_USUARIOS, consultarUsuarios),
  takeLatest(UsuariosTypes.OBTENER_RECURSOS, obtenerRecursos),
  takeLatest(UsuariosTypes.ASIGNAR_ROL, asignarRol),
  takeLatest(UsuariosTypes.REMOVER_ROL, removerRol),
  takeLatest(UsuariosTypes.OBTENER_USUARIO, obtenerUsuario),
];

export default exportedArray;
